import { MenuObjectTypes } from 'enums/menu';
import * as Environment from 'utils/environment';

const env = String(Environment.env()).trim().toLowerCase();
const region = String(Environment.region).trim().toLowerCase();

const sanityDocumentTypeMap = {
  [MenuObjectTypes.PICKER]: 'menuPicker',
  [MenuObjectTypes.COMBO]: 'menuCombo',
  [MenuObjectTypes.ITEM]: 'item',
};

const SANITY_URL = `https://${env}-bk-${region}-whitelabel-cms.rbi.tools/desk/orderLevelContent;menu;`;

export const getSanityModifierUrl = (itemId: string, modifierId: string) =>
  `${SANITY_URL}item;${itemId};${modifierId}`;

export const getSanityDocumentUrl = (type: MenuObjectTypes, id: string) =>
  `${SANITY_URL}${sanityDocumentTypeMap[type]};${id}`;
